import { useEffect, useState } from "react";

/** The camera gateway records about one still a second; one this old means stills have stopped arriving. */
export const STALE_IMAGE_MS = 30_000;

export const parseMs = (iso: string | null): number | null => {
  if (!iso) return null;
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? null : ms;
};

export const formatDuration = (ms: number): string => {
  const abs = Math.abs(ms);
  const sign = ms < 0 ? "-" : "";
  if (abs < 10_000) return `${sign}${(abs / 1000).toFixed(1)} s`;
  if (abs < 120_000) return `${sign}${Math.round(abs / 1000)} s`;
  if (abs < 7_200_000) return `${sign}${Math.round(abs / 60_000)} min`;
  return `${sign}${Math.round(abs / 3_600_000)} h`;
};

/** Re-renders once a second while `active`, so ages keep growing when polls stop landing. */
export const useNow = (active: boolean): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const id = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(id);
  }, [active]);
  return now;
};
